import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../../styles/components/navbar.css';
import logo from '../../assets/images/logo.jpeg';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="navbar-out">
      <div className="navbar-container">
        <Link to="/" className="navbar-brand">
          <img src={logo} alt="PhēnixLoc Logo" />
          <h1>PhēnixLoc</h1>
        </Link>

        <button 
          className="hamburger" 
          onClick={toggleMenu}
          aria-expanded={isMenuOpen}
          aria-label="Toggle navigation"
        >
          <i className="fas fa-bars"></i>
        </button>

        <ul className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
          <li className="navbar-item">
            <Link to="/" className="navbar-link">Home</Link>
          </li>
          <li className="navbar-item">
            <Link to="/register" className="navbar-link">Register</Link>
          </li>
          <li className="navbar-item">
            <a href="https://www.finnovant.com/about-us/" className="navbar-link" target="_blank" rel="noopener noreferrer">About</a>
          </li>
          <li className="navbar-item">
            <Link to="/faq-out" className="navbar-link">FAQ</Link>
          </li>
          <li className="navbar-item">
            <Link to="/contact-us" className="navbar-link">Contact</Link>
          </li>
          <li className="navbar-item">
            <Link to="/received" className="navbar-link">Recipients</Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;